import { ChangeDetectorRef, Component, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { generateUUID } from "src/app/core/generators/generateUUID";
import { ICreateEntradaGate, IGetGateEntradaByIdRespone } from "src/app/services/EntradaGateService/entradaGate.model";
import { EntradaGateService } from "src/app/services/EntradaGateService/entradaGate.service";
import { CaminhaoService } from "src/app/services/CaminhaoService/caminhao.service";
import { CaminhaoResponse, IGetCaminhaoResponse } from "src/app/services/CaminhaoService/caminhao.model";
import { SwalAlertService } from "src/app/services/SwalAlertService/swalAlert.service";
import { CavaloService } from "src/app/services/CavaloService/cavalo.service";
import { AcompanhanteService } from "src/app/services/AcompanhanteService/acompanhante.service";
import { TurnoUtils } from "src/app/core/utils/turno.utils";
import { getInicioJanelaAgendada, isCargaGrao } from "src/app/core/utils/pre-patio.utils";
import { AgendamentoService } from "src/app/services/AgendamentoService/agendamento.service";
import { DestinatarioService } from "src/app/services/DestinatarioService/destinatario.service";
import { IDestinatario } from "src/app/services/DestinatarioService/destinatario.model";
import { CargaService } from "src/app/services/CargaService/carga.service";
import { IGetCarga } from "src/app/services/CargaService/carga.model";
import { TransportadoraService } from "src/app/services/TransportadoraService/transportadora.service";
import { IGetTransportadora } from "src/app/services/TransportadoraService/transportadora.model";
import { ClienteService } from "src/app/services/ClienteService/cliente.service";
import { IGetCliente } from "src/app/services/ClienteService/cliente.model";
import { MotoristaExternoService } from "src/app/services/MotoristaExternoService/motorista-externo.service";
import { cpf } from "cpf-cnpj-validator";
import { ImpressoraService } from "src/app/services/ImpressoraService/impressora.service";
import { IGetReportBase64 } from "src/app/services/ReportService/report.model";
import { ParametrizacaoService } from "src/app/services/ParametrizacaoService/parametrizacao.service";
import { validarPermissao } from "src/app/core/utils/permissionScreen/permissionScreen";

@Component({
  selector: "app-cadastro-entrada",
  templateUrl: "./cadastro-entrada.component.html",
  styleUrls: ["./cadastro-entrada.component.scss"],
})
export class CadastroEntradaComponent implements OnDestroy {
  private subscription$ = new Subscription();
  form: FormGroup;
  activeRoute: string = "";

  pkGateEntrada: any = null;
  title: string = "GATE DE ENTRADAS";
  isMode: number = 0;

  statusInput: boolean = false;
  guid = generateUUID();

  isLoading: boolean = false;

  NM_USUA_MTRT: string = "";
  TX_PLCA_CAVA: string = "";
  TX_PLCA_CRRT_1: string = "";
  TX_PLCA_CRRT_2: string = "";
  TX_PLCA_CRRT_3: string = "";

  vlHoraPrePatio: number = 0;
  avisoPrePatio = "";
  private prePatioPendente: {
    dtAgnd: string | null | undefined;
    carga?: IGetCarga;
    hrInicJanela?: string | null;
  } | null = null;
  flCancelado: boolean = false;
  flJaSaiu: boolean = false;
  motivoCancelamento: string = "";
  camposBloqueadosPorAgendamento = false;

  destinatarios: IDestinatario[] = [];
  cargas: IGetCarga[] = [];
  transportadoras: IGetTransportadora[] = [];
  clientes: IGetCliente[] = [];

  vinculoMap: { [key: number]: string } = {
    1: "Ajudante",
    2: "Conferente",
    3: "Seguran├ºa",
    4: "Representante",
    5: "Visitante",
    6: "Parente",
  };

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private snackBar: MatSnackBar,
    private cd: ChangeDetectorRef,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public cavaloService: CavaloService,
    private entradaGateService: EntradaGateService,
    private caminhaoService: CaminhaoService,
    public swalAlert: SwalAlertService,
    private acompanhanteService: AcompanhanteService,
    private agendamentoService: AgendamentoService,
    private destinatarioService: DestinatarioService,
    private cargaService: CargaService,
    private transportadoraService: TransportadoraService,
    private clienteService: ClienteService,
    private motoristaExternoService: MotoristaExternoService,
    private impressoraService: ImpressoraService,
    private parametrizacaoService: ParametrizacaoService,
  ) {
    this.form = this.inicializarForms();
    this.carregarTarifaPrePatio();
  }

  inicializarForms() {
    return this._inicializarFormulario();
  }

  private _inicializarFormulario() {
    const form = this.fb.group({
      FK_AGND: this.fb.control(null),
      NM_USUA_MTRT: this.fb.control(null),
      TX_PLCA_CAVA: this.fb.control(null, [Validators.required]),
      TX_PLCA_CRRT1: this.fb.control(null),
      TX_PLCA_CRRT2: this.fb.control(null),
      TX_PLCA_CRRT3: this.fb.control(null),
      NM_ACPN: this.fb.control({ value: null, disabled: true }),
      TX_VNCL_MTRT: this.fb.control({ value: null, disabled: true }),
      DT_NASC_ACPN: this.fb.control({ value: null, disabled: true }),
      TX_DOC_VNCL: this.fb.control({ value: null, disabled: true }),
      TX_OBSV_GATE_ENTR: this.fb.control(null),
      DT_AGND: this.fb.control({ value: null, disabled: true }),
      TURNO: this.fb.control({ value: null, disabled: true }),
      JANELA: this.fb.control({ value: null, disabled: true }),
      VL_PRE_PTIO: this.fb.control({ value: null, disabled: true }),
      TX_CPF_MTRT: this.fb.control(null),
      NU_TELE_MTRT: this.fb.control(null),
      TX_NOTA_FISCAL: this.fb.control({ value: null, disabled: true }),
      NU_PESO_TON: this.fb.control({ value: null, disabled: true }),
      NU_VOLUME: this.fb.control({ value: null, disabled: true }),
      NM_CRGA: this.fb.control({ value: null, disabled: true }),
      NM_DEST: this.fb.control({ value: null, disabled: true }),
      NM_TPTD: this.fb.control({ value: null, disabled: true }),
      TX_CNPJ_TPTD: this.fb.control({ value: null, disabled: true }),
      TX_CNTT_TPTD: this.fb.control({ value: null, disabled: true }),
      NM_CLNT: this.fb.control({ value: null, disabled: true }),
      NM_OPER: this.fb.control({ value: null, disabled: true }),
      NU_TELE_OPER: this.fb.control({ value: null, disabled: true }),
      NM_FUNC_OPER: this.fb.control({ value: null, disabled: true })
    });
    return form;
  }

  ngOnInit(): void {
    this.form.get("TX_PLCA_CAVA")?.valueChanges.subscribe((value) => {
      if (value) {
        this.form.get("TX_PLCA_CAVA")?.setValue(value.toUpperCase(), { emitEvent: false });
      }
    });
    const queryParams = this.route.snapshot.queryParamMap;

    this.isMode = Number(queryParams.get("isMode")) ?? 0;

    if (this.isMode === 1) {
      const idGate = Number(queryParams.get("id"));
      this.router.navigate(["cadastro/entrada"], {
        queryParams: { isMode: 3, id: idGate },
        replaceUrl: true,
      });
    } else if (this.isMode === 0) {
      this.inicializarModoCadastro(queryParams);
    } else if (this.isMode === 3) {
      this.inicializarModoVisualizacao(queryParams);
    }
  }

  private preencherFormEdicao(res: IGetGateEntradaByIdRespone) {
    this.flCancelado = res.FL_CNCL ?? false;
    this.flJaSaiu = !!res.FK_GATE_SAID;
    this.motivoCancelamento = res.TX_MOTV_CNCL_GATE_ENTR ?? "";
    this.form.patchValue({
      FK_AGND: res.PK_AGND ?? "",
      NM_USUA_MTRT: res.NM_MTRT,
      TX_PLCA_CAVA: res.TX_PLCA_CAVA,
      TX_PLCA_CRRT1: res.TX_PLCA_CRRT1,
      TX_PLCA_CRRT2: res.TX_PLCA_CRRT2,
      TX_PLCA_CRRT3: res.TX_PLCA_CRRT3,
      TX_OBSV_GATE_ENTR: res.TX_OBSV_GATE_ENTR,
      DT_AGND: res.DT_AGND ? new Date(res.DT_AGND).toLocaleDateString("pt-BR") : "",
      TURNO: TurnoUtils.calcularTurno(res.DT_AGND),
      TX_CPF_MTRT: res.TX_CPF_MTRT,
      NU_TELE_MTRT: res.NU_TELE_MTRT,
      NM_FUNC_OPER: res.NM_FUNC_OPER ?? '---',
    });
  }

  private inicializarModoCadastro(params: ParamMap) {
    const idAgendamento = Number(params.get("idAgendamento"));
    if (!idAgendamento) return;

    this.form.controls["FK_AGND"].setValue(idAgendamento);
    this.buscarAgendamento2(idAgendamento);
  }

  buscarAgendamento2(fkAgendamento?: number) {
    const id = fkAgendamento ?? Number(this.form.controls["FK_AGND"]?.value);

    if (!id || id <= 0) return;

    this.pkGateEntrada = id;

    this.caminhaoService.GetCaminhaoByAgendamento(id).subscribe({
      next: (res: IGetCaminhaoResponse) => {
        this.preencherDadosAgendamento(res);
        this.buscarAcompanhante(id);
        this.buscarDadosAgendamento(id);
      },
      error: (err) => {
        this.tratarAgendamentoNaoEncontrado(err);
      },
    });
  }

  private tratarAgendamentoNaoEncontrado(err?: any) {
    this.swalAlert.handleError(err, "Aten├º├úo!", "Agendamento n├úo encontrado.", "warning");

    this.form.reset();
    this.form.controls["FK_AGND"].setValue("");
    this.camposBloqueadosPorAgendamento = false;
  }

  private preencherDadosAgendamento(res: IGetCaminhaoResponse) {
    this.form.patchValue({
      NM_USUA_MTRT: res.NM_USUA_MTRT,
      TX_PLCA_CAVA: res.TX_PLCA_CAVA,
      TX_PLCA_CRRT1: res.TX_PLCA_CRRT1,
      TX_PLCA_CRRT2: res.TX_PLCA_CRRT2,
      TX_PLCA_CRRT3: res.TX_PLCA_CRRT3,
      TX_CPF_MTRT: res.TX_CPF_MTRT ?? '---',
      NU_TELE_MTRT: res.NU_TELE_MTRT ?? '---'
    });
    this.NM_USUA_MTRT = res.NM_USUA_MTRT;
    this.TX_PLCA_CAVA = res.TX_PLCA_CAVA;
    this.TX_PLCA_CRRT_1 = res.TX_PLCA_CRRT1;
    this.TX_PLCA_CRRT_2 = res.TX_PLCA_CRRT2;
    this.TX_PLCA_CRRT_3 = res.TX_PLCA_CRRT3;
  }

  private inicializarModoVisualizacao(params: ParamMap) {
    this.title = "Visualizar Entrada";

    const idGate = Number(params.get("id"));
    if (!idGate) return;

    this.pkGateEntrada = idGate;

    this.entradaGateService.GetEntradaGateInfoById(idGate).subscribe((response) => {
      this.preencherFormEdicao(response);
      if (response.PK_AGND) {
        this.buscarAcompanhante(response.PK_AGND);
        this.buscarDadosAgendamento(response.PK_AGND);
      }
      this.bloquearFormulario();
    });
  }

  private carregarTarifaPrePatio() {
    this.parametrizacaoService.GetParametrizacaoByName("VL_PRE_PTIO_HORA").subscribe({
      next: (res) => {
        this.vlHoraPrePatio = this.parseTarifa(res?.VL_PRMT);
        if (this.prePatioPendente) {
          const pendente = this.prePatioPendente;
          this.calcularPrePatio(pendente.dtAgnd, pendente.carga, pendente.hrInicJanela);
        }
      },
    });
  }

  private parseTarifa(valor: unknown): number {
    const texto = String(valor ?? "").trim();
    if (!texto) return 0;
    if (texto.includes(",") && texto.includes(".")) {
      return Number(texto.replace(/\./g, "").replace(",", ".")) || 0;
    }
    if (texto.includes(",")) return Number(texto.replace(",", ".")) || 0;
    return Number(texto) || 0;
  }

  private formatarMoeda(valor: number): string {
    return valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  }

  private calcularPrePatio(
    dtAgnd: string | null | undefined,
    carga?: IGetCarga,
    hrInicJanela?: string | null
  ) {
    this.prePatioPendente = { dtAgnd, carga, hrInicJanela };
    this.avisoPrePatio = "";

    if (!isCargaGrao(carga)) {
      this.form.controls["VL_PRE_PTIO"].setValue("R$ 0,00");
      return;
    }

    const janelaInicio = dtAgnd ? getInicioJanelaAgendada(dtAgnd, hrInicJanela) : null;
    if (!janelaInicio) {
      this.form.controls["VL_PRE_PTIO"].setValue(null);
      return;
    }

    const now = new Date();
    if (now >= janelaInicio) {
      this.form.controls["VL_PRE_PTIO"].setValue("R$ 0,00");
      return;
    }

    const minutos = (janelaInicio.getTime() - now.getTime()) / 60000;
    const valor = Math.ceil(minutos / 60) * this.vlHoraPrePatio;
    const texto = this.formatarMoeda(valor);
    this.form.controls["VL_PRE_PTIO"].setValue(texto);
    if (valor > 0) {
      this.avisoPrePatio = `Veículo adiantado. Ao dar entrada agora será cobrado ${texto} de pré-pátio.`;
    }
  }

  private async buscarDadosAgendamento(pkAgnd: number) {
    await Promise.all([this.getDestinatarios(), this.getCargas(), this.getTransportadoras(), this.getClientes()]);

    this.agendamentoService.GetAgendamentoById(pkAgnd).subscribe((response) => {
      const carga = this.cargas.find((c) => c.PK_CRGA === response.FK_CRGA);
      const dest = this.destinatarios.find((d) => d.PK_DTNR === response.FK_DTNR);
      const transportadora = this.transportadoras.find((t) => t.PK_TPTD === response.FK_TPTD);
      const cliente = this.clientes.find((c) => c.PK_CLNT === response.FK_CLNT);

      this.form.patchValue({
        DT_AGND: response.DT_AGND ? new Date(response.DT_AGND).toLocaleDateString("pt-BR") : "",
        TURNO: TurnoUtils.calcularTurno(response.DT_AGND),
        JANELA: this.formatarJanela(response.HR_INIC_JNLA, response.HR_FIM_JNLA),
        TX_NOTA_FISCAL: response.TX_NOTA_FISCAL ?? "---",
        NU_PESO_TON: response.NU_PESO_TON ?? "---",
        NU_VOLUME: response.NU_VOLUME ?? "---",
        NM_CRGA: carga ? carga.TX_CRGA : "---",
        NM_DEST: dest ? dest.NM_DTNR : "---",
        NM_TPTD: transportadora ? transportadora.NM_TPTD : "---",
        TX_CNPJ_TPTD: transportadora?.TX_CNPJ_TPTD ?? "---",
        TX_CNTT_TPTD: transportadora?.TX_CNTT_TPTD ?? "---",
        NM_CLNT: cliente ? cliente.NM_CLNT : "---",
        NM_OPER: response.NM_OPER ?? "---",
        NU_TELE_OPER: response.NU_TELE_OPER ?? "---",
      });
      this.calcularPrePatio(response.DT_AGND, carga, response.HR_INIC_JNLA);
      this.camposBloqueadosPorAgendamento = true;
    });
  }

  private formatarJanela(hrInic?: string | null, hrFim?: string | null): string {
    const inicio = (hrInic ?? "").toString().substring(0, 5);
    const fim = (hrFim ?? "").toString().substring(0, 5);
    if (inicio && fim) return `${inicio} - ${fim}`;
    if (inicio) return inicio;
    return "---";
  }

  async getDestinatarios(): Promise<void> {
    try {
      const res = await this.destinatarioService.getDestinatarios().toPromise();
      if (res?.Destinatarios) this.destinatarios = res.Destinatarios;
    } catch (e) {
      console.error("Erro ao buscar destinat├írios:", e);
    }
  }

  async getCargas(): Promise<void> {
    try {
      const res = await this.cargaService.GetCarga().toPromise();
      if (res?.length) this.cargas = res;
    } catch (e) {
      console.error("Erro ao buscar cargas:", e);
    }
  }

  async getTransportadoras(): Promise<void> {
    try {
      const res: any = await this.transportadoraService.GetTransportadoras().toPromise();
      if (res?.Transportadoras) this.transportadoras = res.Transportadoras;
    } catch (e) {
      console.error("Erro ao buscar transportadoras:", e);
    }
  }

  async getClientes(): Promise<void> {
    try {
      const res: any = await this.clienteService.GetClientes().toPromise();
      if (res?.Clientes || res?.clientes) {
        this.clientes = res.Clientes || res.clientes;
      }
    } catch (e) {
      console.error("Erro ao buscar clientes:", e);
    }
  }

  private bloquearFormulario() {
    this.form.disable();
  }

  createPayload(): ICreateEntradaGate {
    const FK_FUNC_OPER = Number(localStorage.getItem("id"));

    return {
      FK_AGND: this.form.controls["FK_AGND"].value !== "" ? this.form.controls["FK_AGND"].value : null,
      FK_FUNC_OPER: FK_FUNC_OPER,
      NM_USUA_MTRT: this.form.controls["NM_USUA_MTRT"].value,
      TX_CPF: this.form.controls["TX_CPF_MTRT"].value || null,
      TX_TELE: this.form.controls["NU_TELE_MTRT"].value || null,
      TX_PLCA_CAVA: String(this.form.controls["TX_PLCA_CAVA"].value).toUpperCase(),
      TX_PLCA_CRRT1: this.form.controls["TX_PLCA_CRRT1"].value
        ? String(this.form.controls["TX_PLCA_CRRT1"].value).toUpperCase()
        : null,
      TX_PLCA_CRRT2: this.form.controls["TX_PLCA_CRRT2"].value
        ? String(this.form.controls["TX_PLCA_CRRT2"].value).toUpperCase()
        : null,
      TX_PLCA_CRRT3: this.form.controls["TX_PLCA_CRRT3"].value
        ? String(this.form.controls["TX_PLCA_CRRT3"].value).toUpperCase()
        : null,
      TX_OBSV_GATE_ENTR: this.form.controls["TX_OBSV_GATE_ENTR"].value,
    };
  }

  postarDados() {
    if (this.form.valid) {
      const cpfValue = this.form.controls["TX_CPF_MTRT"].value;
      if (cpfValue && !cpf.isValid(String(cpfValue))) {
        this.swalAlert.showAlert("Aten├º├úo!", "O CPF informado ├® inv├ílido.", "warning");
        return;
      }

      const telefoneValue = this.form.controls["NU_TELE_MTRT"].value;
      if (telefoneValue && String(telefoneValue).length < 10) {
        this.swalAlert.showAlert("Aten├º├úo!", "O telefone informado ├® inv├ílido.", "warning");
        return;
      }

      const payload = this.createPayload();
      this.isLoading = true;

      if (this.isMode === 0) {
        this.entradaGateService.CreateEntradaGate(payload, this.guid).subscribe(
          (response) => {
            this.isLoading = false;

            this.swalAlert.showAlert(
              "Sucesso!",
              "A entrada foi registrada com sucesso.",
              "success",
              true,
              false,
              undefined,
              () => { window.location.reload(); }
            );
            // Disparar impress├úo autom├ítica
            this.imprimirTicket(response.PK_GATE_ENTR);
          },
          (error) => {
            this.isLoading = false;
          },
        );
        return;
      } else if (this.isMode === 1) {
        this.isLoading = false;
        this.swalAlert.showAlert("Atenção!", "Não é permitido editar a entrada.", "warning");
        return;
      }

      this.isLoading = false;
      return;
    }
  }

  buscarAgendamento() {
    const FK_AGND_VALUE = Number(this.form.controls["FK_AGND"].value);

    if (FK_AGND_VALUE !== null && FK_AGND_VALUE !== 0) {
      this.pkGateEntrada = FK_AGND_VALUE;
      this.caminhaoService.GetCaminhaoByAgendamento(FK_AGND_VALUE).subscribe({
        next: (res: IGetCaminhaoResponse) => {
          this.form.patchValue({
            NM_USUA_MTRT: res.NM_USUA_MTRT,
            TX_PLCA_CAVA: res.TX_PLCA_CAVA,
            TX_PLCA_CRRT1: res.TX_PLCA_CRRT1,
            TX_PLCA_CRRT2: res.TX_PLCA_CRRT2,
            TX_PLCA_CRRT3: res.TX_PLCA_CRRT3,
            TX_CPF_MTRT: res.TX_CPF_MTRT ?? null,
            NU_TELE_MTRT: res.NU_TELE_MTRT ?? null
          });

          this.NM_USUA_MTRT = res.NM_USUA_MTRT;
          this.TX_PLCA_CAVA = res.TX_PLCA_CAVA;
          this.TX_PLCA_CRRT_1 = res.TX_PLCA_CRRT1;
          this.TX_PLCA_CRRT_2 = res.TX_PLCA_CRRT2;
          this.TX_PLCA_CRRT_3 = res.TX_PLCA_CRRT3;

          this.buscarAcompanhante(FK_AGND_VALUE);
          this.buscarDadosAgendamento(FK_AGND_VALUE);
          this.camposBloqueadosPorAgendamento = true;
        },
        error: (err) => {
          this.swalAlert.handleError(err, "Atenção!", "Agendamento não encontrado.", "warning");
          this.form.reset();
          this.form.controls["FK_AGND"].setValue("");
          this.camposBloqueadosPorAgendamento = false;
          this.avisoPrePatio = "";
          this.prePatioPendente = null;
        },
      });
    }
  }
  buscarMotoristaPorNome() {
    const nome = this.form.controls["NM_USUA_MTRT"].value;
    if (!nome || !String(nome).trim()) return;

    this.motoristaExternoService.GetMotoristaExternoByNome(String(nome).trim()).subscribe({
      next: (res) => {
        if (!res) return;
        this.form.patchValue({
          TX_CPF_MTRT: res.TX_CPF_EXTR ?? null,
          NU_TELE_MTRT: res.NU_TELE_EXTR ?? null,
        });
      },
      error: () => { },
    });
  }

  buscarCaminhaoParams() {
    const PLCA_CAVA = Number(this.form.controls["TX_PLCA_CAVA"].value);

    if (PLCA_CAVA !== null && PLCA_CAVA !== 0) {
      this.pkGateEntrada = PLCA_CAVA;
      this.caminhaoService
        .GetLastVersionCaminhaoParams({
          TX_PLCA_CAVA: this.form.controls["TX_PLCA_CAVA"].value,
        })
        .subscribe({
          next: (res: any) => {
            this.form.patchValue({
              NM_USUA_MTRT: res.NM_USUA_MTRT,
              TX_PLCA_CAVA: res.TX_PLCA_CAVA,
              TX_PLCA_CRRT1: res.TX_PLCA_CRRT1,
              TX_PLCA_CRRT2: res.TX_PLCA_CRRT2,
              TX_PLCA_CRRT3: res.TX_PLCA_CRRT3,
              TX_CPF_MTRT: res.TX_CPF_MTRT ?? null,
              NU_TELE_MTRT: res.NU_TELE_MTRT ?? null
            });

            if (res.FK_AGND) {
              this.form.controls["FK_AGND"].setValue(res.FK_AGND);
              this.buscarAcompanhante(res.FK_AGND);
              this.buscarDadosAgendamento(res.FK_AGND);
            }

            this.NM_USUA_MTRT = res.NM_USUA_MTRT;
            this.TX_PLCA_CAVA = res.TX_PLCA_CAVA;
            this.TX_PLCA_CRRT_1 = res.TX_PLCA_CRRT1;
            this.TX_PLCA_CRRT_2 = res.TX_PLCA_CRRT2!;
            this.TX_PLCA_CRRT_3 = res.TX_PLCA_CRRT3!;
          },
          error: () => { },
        });
    }
  }

  buscarAcompanhante(fkAgnd: number) {
    this.acompanhanteService.GetAcompanhantesByAgendamentoId(fkAgnd).subscribe({
      next: (res) => {
        if (res.ACPN_LIST && res.ACPN_LIST.length > 0) {
          const acompanhantes = res.ACPN_LIST.map((acpn) => ({
            nome: acpn.NM_ACPN,
            vinculo: this.vinculoMap[acpn.NU_VNCL_MTRT] ?? "---",
            dataNascimento: acpn.DT_NASC,
            documento: acpn.TX_DOC_VNCL ?? "---",
          }));
          const nomes = acompanhantes.map((a) => a.nome).join(", ");
          const vinculos = acompanhantes.map((a) => a.vinculo).join(", ");
          const datas = acompanhantes.map((a) => new Date(a.dataNascimento).toLocaleDateString("pt-BR")).join(", ");
          const documentos = acompanhantes.map((a) => a.documento).join(", ");
          this.form.controls["NM_ACPN"].setValue(nomes);
          this.form.controls["TX_VNCL_MTRT"].setValue(vinculos);
          this.form.controls["DT_NASC_ACPN"].setValue(datas);
          this.form.controls["TX_DOC_VNCL"].setValue(documentos);
        } else {
          this.form.controls["NM_ACPN"].setValue(null);
          this.form.controls["TX_VNCL_MTRT"].setValue(null);
          this.form.controls["DT_NASC_ACPN"].setValue(null);
          this.form.controls["TX_DOC_VNCL"].setValue(null);
        }
      },
      error: () => {
        this.form.controls["NM_ACPN"].setValue(null);
        this.form.controls["TX_VNCL_MTRT"].setValue(null);
        this.form.controls["DT_NASC_ACPN"].setValue(null);
        this.form.controls["TX_DOC_VNCL"].setValue(null);
      },
    });
  }

  abrirModal() {
    if (this.form.controls["FK_AGND"].value != null && this.isValorDivergente()) {
      this.swalAlert.showAlert(
        "Aten├º├úo!",
        "Deseja realmente alterar os dados?",
        "warning",
        true,
        true,
        { confirmButtonText: "Permitir Entrada", cancelButtonText: "Cancelar" },
        () => {
          this.postarDados();
        },
      );
    } else {
      this.postarDados();
    }
  }

  imprimirTicket(id: number) {
    this.isLoading = true;

    this.entradaGateService.GetReceiptGateEntradaById(id, 1).subscribe({
      next: (response: IGetReportBase64) => {
        this.isLoading = false;
        this.impressoraService.impressoraTicket(response.ReportBase64, "text/plain");
      },
      error: (_error) => {
        this.isLoading = false;
      },
    });
  }

  navegarSaida() {
    if (!this.podeRegistrarSaida()) {
      return;
    }

    this.router.navigate(["cadastro/saida-gate"], {
      queryParams: {
        idEntrada: this.pkGateEntrada,
        isMode: 0,
      },
    });
  }

  podeRegistrarSaida(): boolean {
    return (
      validarPermissao('cadastrarGateSaida', 'incluir') &&
      !!this.pkGateEntrada &&
      !this.flCancelado &&
      !this.flJaSaiu
    );
  }

  goTo(route: string) {
    this.router.navigate([route]);
    setTimeout(() => {
      this.activeRoute = this.router.url;
      this.cd.detectChanges();
    }, 200);
  }

  isValorDivergente(): boolean {
    let isDivergente = false;
    if (
      this.NM_USUA_MTRT != this.form.controls["NM_USUA_MTRT"].value ||
      this.TX_PLCA_CAVA != this.form.controls["TX_PLCA_CAVA"].value ||
      this.TX_PLCA_CRRT_1 != this.form.controls["TX_PLCA_CRRT1"].value ||
      this.TX_PLCA_CRRT_2 != this.form.controls["TX_PLCA_CRRT2"].value ||
      this.TX_PLCA_CRRT_3 != this.form.controls["TX_PLCA_CRRT3"].value
    ) {
      isDivergente = true;
    }
    console.log(this.NM_USUA_MTRT);
    console.log(this.form.controls["NM_USUA_MTRT"].value);
    return isDivergente;
  }
  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
